import {createContext} from "react"

const ModalNavContext = createContext({
    timerModalNav: false,
    setTimerModalNav: () => {}
})

export default ModalNavContext;